import { useList } from "@refinedev/core";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { PageHeader } from "@/components/forms/PageHeader";
import { MoneyDisplay } from "@/components/forms/MoneyDisplay";
import { formatDate } from "@/lib/formatters";

const ESTADO_LABEL: Record<string, string> = {
  registrada: "Registrada",
  devolucion_pendiente: "Devolución pendiente",
  devolucion_recibida: "Devolución recibida",
  aplicada: "Aplicada",
  cerrada: "Cerrada",
};

export function AnulacionesListPage() {
  const { data, isLoading } = useList({
    resource: "anulaciones",
    sorters: [{ field: "registrado_en", order: "desc" }],
    meta: { select: "*, ventas(numero_consecutivo, cliente_nombre, valor_total)" },
  });

  return (
    <div>
      <PageHeader title="Anulaciones" subtitle="Devoluciones de aliados y gastos" />
      {isLoading ? (
        <div className="card p-8 text-center text-fg-muted">Cargando...</div>
      ) : data?.data.length === 0 ? (
        <div className="card p-8 text-center text-fg-muted">Sin anulaciones</div>
      ) : (
        <ul className="space-y-2">
          {data?.data.map((a) => {
            const venta = a.ventas as {
              numero_consecutivo: number;
              cliente_nombre: string;
              valor_total: number;
            };
            return (
              <li key={a.id as string} className="card p-4">
                <div className="flex items-start gap-3">
                  <XCircle className="size-5 text-error mt-0.5" />
                  <div className="flex-1">
                    <p className="font-medium">
                      Venta #{venta?.numero_consecutivo} · {venta?.cliente_nombre}
                    </p>
                    <p className="text-sm text-fg-muted">
                      {formatDate(a.fecha_anulacion as string)} · {a.motivo as string}
                    </p>
                    <p className="text-xs text-fg-muted mt-1">
                      Estado: {ESTADO_LABEL[a.estado as string]}
                      {Boolean(a.monto_gastos_cancelacion) && (
                        <>
                          {" · Gastos: "}
                          <MoneyDisplay value={a.monto_gastos_cancelacion as number} />
                        </>
                      )}
                    </p>
                  </div>
                  <Link to={`/ventas/${a.venta_id}`} className="text-xs text-brand hover:underline">
                    Ver venta
                  </Link>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
